import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GlobalState {
  serverError: boolean;
}

const initialState: GlobalState = {
  serverError: false,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setServerError: (state, action: PayloadAction<boolean>) => {
      state.serverError = action.payload;
    },
  },
});

export const { setServerError } = globalSlice.actions;
export default globalSlice.reducer;
